import {modalAlert} from "./modules/modalAlert.js";
import {openNotification} from "./modules/openNotification.js";
import {refreshNotifications} from "./modules/refreshNotifications.js";
import {APIRequest} from "./modules/APIRequest.js";
import {saveAppState} from "./modules/saveAppState.js";

(async ()=>{
	'use strict';
	window.HELP_IMPROVE_VIDEOJS = false;

	$(document).on('click', '#side_bar_dasbhoard_btn', async function(e){
		e.preventDefault();
		await saveAppState('dashboard');
		location.href = 'dashboard.php';
	});

	$(document).on('click', 'a[data-alert-message]', function (e) {
		e.preventDefault();
		var message = $(this).data('alert-message');
		var title = $(this).data('alert-title') || 'Notice';
		modalAlert(message, title);
	});
	
	$(document).on('click', '[data-cc-text]', async function (e) {
		e.preventDefault();
		await navigator.clipboard.writeText($(this).data('cc-text'));
		await modalAlert('Link copied to clipboard!');
	});
	
	$('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
		if (!$(this).next().hasClass('show')) {
			$(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
		}
		var $subMenu = $(this).next('.dropdown-menu');
		$subMenu.toggleClass('show');
	
	
		$(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
			$('.dropdown-submenu .show').removeClass('show');
		});
	
	
		return false;
	});

	var request = new APIRequest();
	request.set('getPageSidebar');
	var data = (await request.send()).getPageSidebar.data;

	if (!data) return;

	refreshNotifications();

	if(data.tester){
		$(".tester-sidebr").show();
	}

	if (data.has_downloads) {
		$("#sidebar-downloads-menu-item").show();
	}

	if (data.static_content.length) {
		$("#challenge-sidebar-content").parent().parent().show();
	}

	if (data.groups.length || data.egroups.length) {
		$("#group-sidebar-content").parent().parent().show();
	}

	if (data.videos.length) {
		$("#video-sidebar-content").parent().parent().show();
	}

	if (data.features && data.features.map(f => +f.id).indexOf(1) > -1) {
		$("#sidebar-recipes-menu-item").show();
	}

	$("#challenge-sidebar-content").append(data.static_content.map(itm => {
		return `<a href="content.php?id=${itm.id}" class="collapse-item" style='overflow:hidden;'><i class="fas fa-align-justify"></i> <span>${itm.title}</span></a>`;
	}).join(''));

	$("#group-sidebar-content").append(data.groups.map(itm => {
		return `<a href="group.php?gid=${itm.id}" class="collapse-item" style='overflow:hidden;'><i class="fas fa-users"></i> <span>${itm.name}</span></a>`;
	}).join(''));

	$("#group-sidebar-content").append(data.egroups.map(itm => {
		return `<a href="egroup.php?gid=${itm.id}" class="collapse-item" style='overflow:hidden;'><i class="fas fa-users"></i> <span>${itm.name}</span></a>`;
	}).join(''));

	$("#video-sidebar-content").append(data.videos.map(itm => {
		return `<a href="video.php?vid=${itm.id}" class="collapse-item" style='overflow:hidden;'><i class="fas fa-film"></i> <span>${itm.name}</span></a>`;
	}).join(''));

	$(document).on('click', '.notification-link', async function (e) {
		e.preventDefault();
		var nid = $(this).data('id');
		openNotification(nid);
	});

	// Ping the server every 60 seconds to prevent session timeout.
	setInterval(refreshNotifications, 60 * 1000);

	// Close the sidebar if viewport is less than 600px wide
	if (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 600) {
		document.body.classList.add('sidebar-toggled');
		document.querySelectorAll('.sidebar').forEach(sb => {
			sb.classList.add('toggled');
		});
	}

})();